import { useEffect, useState } from 'react';

import { createAxiosInstance } from '@src/api';

import PlaceHolderImage from './placeholder-image.png';

export default function ImageDivThumb({ src, className, css }) {
  const [imgSrc, setImgSrc] = useState(null);
  var controller = new AbortController();

  const TitilerReq = createAxiosInstance();
  async function FetchImage() {
    try {
      const result = await TitilerReq.get(src, {
        responseType: 'blob',
        signal: controller.signal
      });

      var reader = new FileReader();
      reader.readAsDataURL(result.data);
      reader.onloadend = function () {
        var base64data = reader.result;
        setImgSrc(base64data);
      };
    } catch (error) {
      // removes this as it clutters sentry logs - this is generally triggered when ui actions are performed extremely fast or the map is unmounted quickly
      // console.error(error);
      return null;
    }
  }
  useEffect(() => {
    FetchImage();
    return () => controller.abort();
  }, [src]);

  return (
    <div className={className}>
      {imgSrc !== null ? (
        <img src={imgSrc} className={className} style={{ ...css }} />
      ) : (
        <img src={PlaceHolderImage} className={className} style={{ ...css }} />
      )}
    </div>
  );
}
